import { render, staticRenderFns } from "./install-archify.vue?vue&type=template&id=949c4d86&scoped=true&"
import script from "./install-archify.vue?vue&type=script&lang=js&"
export * from "./install-archify.vue?vue&type=script&lang=js&"
import style0 from "./install-archify.vue?vue&type=style&index=0&id=949c4d86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949c4d86",
  null
  
)

export default component.exports